var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenValidationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11361 18.4478L3.26359 12.5978C2.91214 12.2463 2.91214 11.6765 3.26359 11.325L4.53636 10.0522C4.88782 9.70068 5.4577 9.70068 5.80916 10.0522L9.75 13.993L18.1908 5.55217C18.5423 5.20071 19.1122 5.20071 19.4636 5.55217L20.7364 6.82497C21.0879 7.17643 21.0879 7.74628 20.7364 8.09777L10.3864 18.4478C10.0349 18.7993 9.46504 18.7993 9.11361 18.4478Z",
    fill: "#648001"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenValidationTick);
export default __webpack_public_path__ + "static/media/green-validation-tick.89638ba3.svg";
export { ForwardRef as ReactComponent };